const SocialResponsibility = ({ data }) => (
  <div className="lg:w-2/3 lg:mx-auto md:pt-40 py-28 md:pb-80 px-6 md:px-10 lg:px-10">
    <div className="bg-blue-850 text-white p-4 lg:p-6">
      <h2 className="text-4xl mb-10">Social Responsibilities</h2>

      <p className="xl:text-lg md:pl-3 lg:pl-6 break-all">
        {data?.socialResponsibilties}
      </p>
    </div>
  </div>
);

export default SocialResponsibility;
